import { useEffect, useState } from 'react';

import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import { ConfirmationSuccess } from './ConfirmationSuccess';
import { ConfirmPharmacy } from './ConfirmPharmacy';
import { PharmacyHubWelcome } from './PharmacyHubWelcome';

export const enum PharmacyHubStep {
  welcome = 'welcome',
  confirm = 'confirm',
  success = 'success',
}

export type SelectedPharmacy = {
  name: string;
  address?: string;
  phone?: string;
};

export const PharmacyHubDemoJourney = () => {
  const [currentStep, setCurrentStep] = useState<PharmacyHubStep | null>(null);
  const [selectedPharmacy, setSelectedPharmacy] = useState<SelectedPharmacy>();

  const { search, pathname } = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(search);
  const patient = decodeURIComponent(params.get('patient') || 'Sam');
  const doctor = decodeURIComponent(params.get('doctor') || 'Krishna');
  const phone = decodeURIComponent(params.get('phone') || '');

  useEffect(() => {
    updateCurrentStep();
  }, [search]);

  const updateCurrentStep = () => {
    const params = new URLSearchParams(search);
    const currentStep = params.get('step');
    if (currentStep === PharmacyHubStep.success && selectedPharmacy == undefined) {
      setCurrentStep(PharmacyHubStep.confirm);
      setStep(PharmacyHubStep.confirm);
    } else if (currentStep == PharmacyHubStep.confirm || currentStep == PharmacyHubStep.success) {
      setCurrentStep(currentStep);
    } else {
      // Always show welcome page on non existing params or unrecognized params
      setCurrentStep(PharmacyHubStep.welcome);
    }
  };

  const setStep = (step: PharmacyHubStep) => {
    const params = new URLSearchParams(search);
    params.set('step', step);
    history.push({ pathname: pathname, search: '?' + params.toString() });
  };

  if (currentStep == PharmacyHubStep.confirm) {
    return <ConfirmPharmacy setSelectedPharmacy={setSelectedPharmacy} setStep={setStep} />;
  }

  if (currentStep == PharmacyHubStep.success && selectedPharmacy) {
    return <ConfirmationSuccess selectedPharmacy={selectedPharmacy} phone={phone} patient={patient} doctor={doctor} />;
  }

  return (
    <PharmacyHubWelcome
      doctor={doctor}
      patient={patient}
      handleStartConfirmPharmacyClick={() => setStep(PharmacyHubStep.confirm)}
    />
  );
};
